import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Holidays() {
  const [holidays, setHolidays] = useState([]);
  const [year, setYear]         = useState(new Date().getFullYear());
  const [showForm, setShowForm] = useState(false);
  const [form, setForm]         = useState({ name:'', date:'' });
  const [loading, setLoading]   = useState(false);

  useEffect(() => { fetchData(); }, [year]);

  const fetchData = async () => {
    const res = await api.get(`/holidays?year=${year}`);
    setHolidays(res.data);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/holidays', form);
      toast.success('Holiday added');
      setShowForm(false);
      setForm({ name:'', date:'' });
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to add holiday');
    } finally { setLoading(false); }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Remove "${name}" from holidays?`)) return;
    try {
      await api.delete(`/holidays/${id}`);
      toast.success('Holiday removed');
      fetchData();
    } catch (err) { toast.error('Failed to remove'); }
  };

  const dayName = (dateStr) => new Date(dateStr).toLocaleDateString('en-IN', { weekday:'long' });

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{marginBottom:0}}>Public Holidays</h1>
        <div className="flex gap-8">
          <select className="form-control" style={{width:100}} value={year} onChange={e => setYear(e.target.value)}>
            {[new Date().getFullYear()-1, new Date().getFullYear(), new Date().getFullYear()+1].map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
          <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
            {showForm ? 'Cancel' : '+ Add Holiday'}
          </button>
        </div>
      </div>

      {showForm && (
        <div className="card mb-16">
          <div className="card-title">Add Public Holiday</div>
          <form onSubmit={handleAdd}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Holiday Name</label>
                <input className="form-control" required value={form.name}
                  onChange={e => setForm(f=>({...f,name:e.target.value}))} placeholder="e.g. Diwali"/>
              </div>
              <div className="form-group">
                <label className="form-label">Date</label>
                <input className="form-control" type="date" required value={form.date}
                  onChange={e => setForm(f=>({...f,date:e.target.value}))}/>
              </div>
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Adding...' : 'Add Holiday'}
            </button>
          </form>
        </div>
      )}

      <div className="card">
        <div className="card-title">Holidays for {year} ({holidays.length} total)</div>
        {holidays.length === 0 ? (
          <div className="empty-state"><div className="icon">🎉</div><p>No holidays added for {year} yet</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>#</th><th>Holiday Name</th><th>Date</th><th>Day</th><th>Added By</th><th>Action</th></tr></thead>
              <tbody>
                {holidays.map((h, i) => (
                  <tr key={h.id}>
                    <td>{i+1}</td>
                    <td style={{fontWeight:500}}>{h.name}</td>
                    <td>{new Date(h.date).toLocaleDateString('en-IN',{day:'2-digit',month:'long',year:'numeric'})}</td>
                    <td>{dayName(h.date)}</td>
                    <td>{h.added_by}</td>
                    <td>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(h.id, h.name)}>Remove</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
